import { ThemeModule } from '../../front/lib/ThemeModule';
import { createApp } from 'vue';
import ConferenceBookingModal from './ConferenceBookingModal.vue';
export class ConferenceBookingBtn extends ThemeModule {
    constructor() {
        super(...arguments);
        this.modalApp = null;
    }
    init() {
        var _a, _b, _c;
        const bookingFormUrl = (_b = (_a = this.json) === null || _a === void 0 ? void 0 : _a.event) === null || _b === void 0 ? void 0 : _b.BookingFormUrl;
        if (bookingFormUrl) {
            if (!ConferenceBookingBtn.modalApps[bookingFormUrl]) {
                ConferenceBookingBtn.modalApps[bookingFormUrl] = this.instantiateModal(bookingFormUrl);
                this.addCleanupHandler(() => {
                    if (ConferenceBookingBtn.modalApps[bookingFormUrl]) {
                        delete ConferenceBookingBtn.modalApps[bookingFormUrl];
                    }
                });
            }
            this.modalApp = ConferenceBookingBtn.modalApps[bookingFormUrl];
            (_c = this.getElementById('btn')) === null || _c === void 0 ? void 0 : _c.addEventListener('click', () => {
                var _a;
                (_a = this.modalApp) === null || _a === void 0 ? void 0 : _a.show();
            });
        }
        else {
            // If no booking form URL is provided, just remove the button
            this.destroy();
        }
    }
    instantiateModal(bookingFormUrl) {
        const containerEl = document.createElement('div');
        document.body.appendChild(containerEl);
        const app = createApp(ConferenceBookingModal, { bookingFormUrl, controller: this });
        return app.mount(containerEl);
    }
}
// Store all instantiated modal apps in a static object to avoid instantiating them multiple times
ConferenceBookingBtn.modalApps = {};
